import React from "react";

const GROUP_ORDER = [
  { key: "anaerobe", label: "Anaerobic commensals" },
  { key: "aerobe", label: "Aerobes" },
  { key: "yeast", label: "Yeasts" },
  { key: "other", label: "Other" },
];

const STATUS_TONE = {
  low: { bar: "#D49A44", text: "text-[#8a6620]", bg: "bg-[#D49A44]/15", label: "Low" },
  high: { bar: "#C05C42", text: "text-[#8F3A3A]", bg: "bg-[#8F3A3A]/10", label: "High" },
  normal: { bar: "#2A3B2C", text: "text-[#2A3B2C]", bg: "bg-[#2A3B2C]/10", label: "Normal" },
  unknown: { bar: "#9A8F7E", text: "text-[#5C6359]", bg: "bg-[#E5DEC3]", label: "—" },
};

export const OrganismBars = ({ organisms }) => {
  if (!organisms || organisms.length === 0) {
    return <p className="text-sm text-[#5C6359]">No organisms recorded.</p>;
  }
  return (
    <div className="space-y-6" data-testid="organism-bars">
      {GROUP_ORDER.map(({ key, label }) => {
        const items = organisms.filter((o) => (o.group || "other") === key);
        if (items.length === 0) return null;
        const counts = items.map((o) => (typeof o.count === "number" ? o.count : 0));
        const maxCount = Math.max(...counts, 1);
        return (
          <div key={key} data-testid={`organism-group-${key}`}>
            <p className="text-[10px] uppercase tracking-widest text-[#C05C42] mb-3">{label} · {items.length}</p>
            <div className="space-y-3">
              {items.map((o) => {
                const tone = STATUS_TONE[o.status] || STATUS_TONE.unknown;
                const hasCount = typeof o.count === "number";
                const widthPct = hasCount ? Math.max(6, (o.count / maxCount) * 100) : 100;
                const ref = (o.reference_low != null || o.reference_high != null)
                  ? `ref ${o.reference_low ?? "–"}–${o.reference_high ?? "–"}` : null;
                return (
                  <div key={o.id || o.organism} data-testid={`organism-${(o.organism || "").replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}>
                    <div className="flex items-baseline justify-between gap-3 mb-1">
                      <span className="font-serif text-[15px] text-[#2D322B]">{o.organism}</span>
                      <span className="text-xs text-[#5C6359] shrink-0">
                        {o.count_text || (hasCount ? o.count : "—")}{o.unit ? ` ${o.unit}` : ""}
                        {o.status !== "unknown" && (
                          <span className={`ml-2 text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-full ${tone.bg} ${tone.text}`}>{tone.label}</span>
                        )}
                      </span>
                    </div>
                    <div className="h-2 rounded-full bg-[#E5DEC3] overflow-hidden">
                      <div className="h-full rounded-full transition-all" style={{ width: `${widthPct}%`, background: tone.bar, opacity: hasCount ? 1 : 0.4 }} />
                    </div>
                    {(ref || o.note) && (
                      <p className="text-[10px] text-[#9A8F7E] mt-1">{ref}{ref && o.note ? " · " : ""}{o.note}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
